import { createStore } from "mipd"

const store = createStore()

export const isConnectorInstalled = (
  rdns: string | readonly string[] | undefined,
) => {
  if (!rdns) {
    return false
  }
  if (typeof rdns === "string") {
    return store.findProvider({ rdns }) !== undefined
  }
  return rdns.some(rdns => store.findProvider({ rdns }) !== undefined)
}
